import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';
import * as global from "../../data/global";

function fallbackGlyphGeometry() {
    if (!global.gw.geometries.AnSpace) {
        global.gw.geometries.AnSpace = new THREE.PlaneGeometry(10, 10);
    }
    return global.gw.geometries.AnSpace;
}

function geometryFromGltfNodes(nodes, name) {
    const direct = nodes?.[name];
    if (direct?.geometry) return direct.geometry;
    if (direct?.children?.length) {
        for (const child of direct.children) {
            if (child?.geometry) return child.geometry;
        }
    }
    for (const value of Object.values(nodes || {})) {
        if (value?.geometry) return value.geometry;
        if (value?.children?.length) {
            for (const child of value.children) {
                if (child?.geometry) return child.geometry;
            }
        }
    }
    return null;
}

export function Text3D(props) {
    const { nodes } = useGLTF(`/3ds/an/${props.an}.${props.ext}`);
    if (!global.gw.geometries[props.an]) {
        if (props.an === "AnSpace") {
            global.gw.geometries[props.an] = fallbackGlyphGeometry();
        } else {
            const geom = geometryFromGltfNodes(nodes, props.an);
            global.gw.geometries[props.an] = geom || fallbackGlyphGeometry();
        }
    }
    const geometry = global.gw.geometries[props.an];
    if (!geometry) return null;
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (props.an === "AnSpace" || (props.meshProps && props.meshProps.isHidden)) {
                        e.visible = false;
                    }
                }}
                name={props.an}
                geometry={geometry}
                rotation={props.an === "AnSpace" ? [Math.PI / 2, 0, Math.PI / 2] : [Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}
